import { render, staticRenderFns } from "./productWX.vue?vue&type=template&id=ab2ca328&scoped=true&"
import script from "./productWX.vue?vue&type=script&lang=js&"
export * from "./productWX.vue?vue&type=script&lang=js&"
import style0 from "./productWX.vue?vue&type=style&index=0&id=ab2ca328&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2ca328",
  null
  
)

export default component.exports